/**
 * Placeholder interpolation for the readiness step-flow verdict copy.
 * Values are supplied per render; unknown placeholders resolve to ''.
 */
export const interpolateStepTemplate = (
  template: string,
  values: Record<string, string | number>
): string =>
  template.replace(/\{\{(\w+)\}\}/g, (_match, key: string) => {
    const value = values[key];
    return value === undefined ? '' : String(value);
  });

/** Uppercases the first character — for templates that open with a placeholder. */
export const capitaliseFirst = (text: string): string =>
  text.charAt(0).toUpperCase() + text.slice(1);

/** English ordinal, e.g. 1 → "1st", 4 → "4th", 22 → "22nd". */
export const toOrdinal = (value: number): string => {
  const rem100 = Math.abs(value) % 100;
  if (rem100 >= 11 && rem100 <= 13) return `${value}th`;

  switch (Math.abs(value) % 10) {
    case 1:
      return `${value}st`;
    case 2:
      return `${value}nd`;
    case 3:
      return `${value}rd`;
    default:
      return `${value}th`;
  }
};

/** Picks the copy variant for a post-GW1 race state. */
export const pickByRaceState = <T>(
  state: 'behind' | 'level' | 'ahead' | 'lateStart',
  variants: { behind: T; level: T; ahead: T; lateStart: T }
): T => variants[state];
